import { activityListQueryFn } from "@gymflow/api";

import useGymflowModels from "../../store";
import { PaginatedSelect } from ".";

export interface ActivitySelectOption {
  label: string;
  value: number;
}

interface ActivitySelectProps {
  value: ActivitySelectOption[];
  onChange: (newValue: ActivitySelectOption[]) => void;
  allowMultipleSelection?: boolean;
  placeholder?: string;
  isClearable?: boolean;
}

export function ActivitySelect({
  value,
  onChange,
  allowMultipleSelection,
  placeholder,
  isClearable,
}: ActivitySelectProps) {
  const { api } = useGymflowModels();

  return (
    <PaginatedSelect
      isMulti={allowMultipleSelection}
      placeholder={placeholder}
      loadOptions={async (_, __, additional) => {
        const activityList = await activityListQueryFn({
          api,
          opts: {
            status: "ACTIVE",
            page: additional.page,
          },
        });
        return {
          options: activityList.content.map((activity) => ({
            label: activity.name,
            value: activity.id,
          })),
          hasMore: !activityList.last,
          additional: {
            page: additional.page + 1,
          },
        };
      }}
      value={value}
      onChange={(newValue) => {
        onChange(allowMultipleSelection ? newValue : [newValue]);
      }}
      isClearable={isClearable}
    />
  );
}
